import { render, staticRenderFns } from "./PopoverActionButton.vue?vue&type=template&id=1475a706&scoped=true&"
import script from "./PopoverActionButton.vue?vue&type=script&lang=js&"
export * from "./PopoverActionButton.vue?vue&type=script&lang=js&"
import style0 from "./PopoverActionButton.vue?vue&type=style&index=0&id=1475a706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1475a706",
  null
  
)

export default component.exports